import React from "react";
import Box from "@mui/material/Box";
import LobbyPlayerBox from "./LobbyPlayerBox";
import LobbyInvitePlayersBox from "./LobbyInvitePlayersBox";

const FriendSlot = ({
  player,
  slotClass,
  sx,
  onInvite,
  friendsOnline = 0,
  pendingInvite = null,
  onKick,
  friendlist,
  pendingRequests,
  handleSendRequestFriend,
  lobbyState,
  currentLobbyCode,
  isCurrentUserLeader = false,
  canFlipCards = true,
  showUnavailableActionMessage,
  avatarCacheBust = 0,
}) => {
    return (
      <Box
        component="div"
        className={slotClass || undefined}
        sx={sx}
        onClick={player ? undefined : onInvite}
      >
        {player ? (
          <LobbyPlayerBox 
            player={player} 
            onKick={onKick} 
            friendlist={friendlist} 
            handleSendRequestFriend={handleSendRequestFriend} 
            pendingRequests={pendingRequests}
            lobbyState={lobbyState}
            currentLobbyCode={currentLobbyCode}
            isCurrentUserLeader={isCurrentUserLeader}
            canFlipCards={canFlipCards}
            showUnavailableActionMessage={showUnavailableActionMessage}
            avatarCacheBust={avatarCacheBust}
          />
        ) : (
          <LobbyInvitePlayersBox friendsOnline={friendsOnline} pendingInvite={pendingInvite} avatarCacheBust={avatarCacheBust} />
        )}
      </Box>
    );
};

export default FriendSlot;
